export default __webpack_public_path__ + "static/media/icon-coin-comp.f21b380a.svg";